import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import isNil from "lodash/isNil";
import { ManageRolesFormType } from "PFApp/types/activity_form/manage_roles_form_schema";
import { Id } from "PFCore/types";

import { getRoleKey } from "../manage_roles.utils";

// Narrow empty check — does not treat 0 or false as empty, so valid numeric values like
// min_required_count = 0 are not incorrectly rejected.
export const isEmptyValue = (value: unknown): boolean =>
  isNil(value) ||
  (typeof value === "string" && value.trim() === "") ||
  (Array.isArray(value) && isEmpty(value));

type RoleFieldChange = {
  roleId: Id;
  fieldName: string;
  nextValue: unknown;
  prevValue: unknown;
};

export const diffRoles = (
  prev: ManageRolesFormType[],
  next: ManageRolesFormType[],
  trackedKeys: Set<string>
): RoleFieldChange[] => {
  const prevByKey = new Map<Id, ManageRolesFormType>(
    prev.filter(Boolean).map((role) => [getRoleKey(role), role])
  );

  const changes: RoleFieldChange[] = [];
  next.forEach((role) => {
    if (!role) {
      return;
    }

    const roleKey = getRoleKey(role);
    const prevRole = prevByKey.get(roleKey);

    if (!prevRole) {
      return;
    }

    trackedKeys.forEach((fieldName) => {
      const nextValue = get(role, fieldName);
      const prevValue = get(prevRole, fieldName);

      if (!isEqual(nextValue, prevValue)) {
        changes.push({ roleId: roleKey, fieldName, nextValue, prevValue });
      }
    });
  });

  return changes;
};
